// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1_YiD","content":"LayoutSettings_content__3JHmD"};